import React, { memo, useState, useCallback, MouseEventHandler } from 'react';

import classNames from 'classnames';
import { Button } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import ColumnsSelection from './columns-selection/columns-selection';
import type { TableConfigObjectAdapter } from '../../../stores/alerts-view/table-config-object-adapter';

interface Props {
	tableConfig: TableConfigObjectAdapter;
}

function ColumnsButton({ tableConfig }: Props) {
	const [columnsSelectionVisible, setColumnsSelectionVisible] = useState<boolean>(false);

	const changeColumnsSelectionState = useCallback<MouseEventHandler<HTMLElement>>(
		e => {
			e.stopPropagation();
			setColumnsSelectionVisible(!columnsSelectionVisible);
		},
		[columnsSelectionVisible]
	);

	const handleCloseColumnSelection = useCallback(() => setColumnsSelectionVisible(false), []);

	return (
		<div className="columns-button">
			<Button
				role="button"
				className={classNames({ active: columnsSelectionVisible })}
				data-test-id="columns-button"
				onClick={changeColumnsSelectionState}
			>
				<BringgIcon iconName={BringgFontIcons.Settings} />
			</Button>

			{columnsSelectionVisible && (
				<ColumnsSelection tableConfig={tableConfig} onOutsideClick={handleCloseColumnSelection} />
			)}
		</div>
	);
}

export default memo(ColumnsButton);
